import { createActions, createReducer } from 'reduxsauce'

import ConsultaFundosSaldosReceitasService from '../../servicos/ConsultaFundosSaldosReceitasService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaFundosSaldosReceitasInicio: [],
    buscaConsultaFundosSaldosReceitasErro: ['erro'],
    buscaConsultaFundosSaldosReceitasSucesso: ['consultaFundosSaldosReceitas'],
    limpar: [],
    setConsultaFundosSaldosReceitasEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaFundosSaldosReceitas = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaFundosSaldosReceitasInicio())
        let serv = new ConsultaFundosSaldosReceitasService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaFundosSaldosReceitasSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaFundosSaldosReceitasErro(error)))
    }
}

const buscaConsultaFundosSaldosReceitasInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaFundosSaldosReceitasErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaFundosSaldosReceitasSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaFundosSaldosReceitas.resultado,
        dataSincronizacaoDados: action.consultaFundosSaldosReceitas.dataSincronizacaoDados,
        fonte: action.consultaFundosSaldosReceitas.fonte,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaFundosSaldosReceitasEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_FUNDOS_SALDOS_RECEITAS_INICIO]: buscaConsultaFundosSaldosReceitasInicio,
    [Types.BUSCA_CONSULTA_FUNDOS_SALDOS_RECEITAS_ERRO]: buscaConsultaFundosSaldosReceitasErro,
    [Types.BUSCA_CONSULTA_FUNDOS_SALDOS_RECEITAS_SUCESSO]: buscaConsultaFundosSaldosReceitasSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_FUNDOS_SALDOS_RECEITAS_ESTADO_DT]: setConsultaFundosSaldosReceitasEstadoDT,
})
